import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store, persistor } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { PWAProvider } from './context/PWAContext';
import 'react-toastify/dist/ReactToastify.css';
import './styles/index.css';
import App from './App';
import Loading from './components/common/Loading';

// This tells the browser to install and run your /public/service-worker.js file.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('Service Worker registered successfully:', registration);
      })
      .catch(error => {
        console.error('Service Worker registration failed:', error);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<Loading />} persistor={persistor}> 
        <PWAProvider>
          <App />
        </PWAProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);